import * as React from 'react';
import { ReactComponent as Logo } from '../../assets/images/shell-logo.svg';

import styled from 'styled-components';
import { RegionsMenu } from '../../components/regions-menu/regions-menu';
import { MangoNavy, White } from '../../styles/colours';

const StyledHeader = styled.header`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: transparent;
  z-index: 2;

  @media print {
    display: none;
  }
`;

const StyledLogoLink = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledSiteTitle = styled.h1`
  padding: 0 1rem;
  margin: 0;
  font-size: 1rem;
  background: ${MangoNavy};
  color: ${White};
`;

export const Header = () => {
  return (
    <StyledHeader>
      <StyledLogoLink href="/">
        <Logo />
        <StyledSiteTitle>love.shell.com</StyledSiteTitle>
      </StyledLogoLink>
      <RegionsMenu />
    </StyledHeader>
  );
};
